module.exports = __webpack_public_path__ + "img/sicon_02.b66364e9.png";